import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import type { Id } from 'convex/_generated/dataModel'
import { LoadingScreen } from '@/components/common/LoadingScreen'
import MyDiyProjectsPage from '@/features/projects/views/components/MyDiyProjectsPage'

export const Route = createFileRoute('/_authed/projects/')({
  loader: async ({ context }) => {
    // Get the current profile to access groupId
    const profileData = await context.queryClient.ensureQueryData(
      convexQuery(api.users.getCurrentProfile, {})
    )

    if (profileData?.profile.groupId) {
      // Preload projects for the group
      await context.queryClient.ensureQueryData(
        convexQuery(api.diy.projects.listDiyProjects, {
          groupId: profileData.profile.groupId as Id<'groups'>,
        })
      )
    }
  },
  pendingComponent: () => <LoadingScreen message="Loading your projects..." />,
  component: ProjectsRouteWrapper,
})

function ProjectsRouteWrapper() {
  return (
    <Suspense fallback={<LoadingScreen message="Loading your projects..." />}>
      <MyDiyProjectsPage />
    </Suspense>
  )
}
